import {
    AccountSubtype,
    AccountType,
} from "@common/constants/domains/accounting/accounts";
import { Account } from "@common/types/domains/accounting/account";
import { ImportedAccount } from "@common/schemas/domains/accounting/importedAccount.schema";

interface ResolveMappedKickAccountParams {
    account: Pick<ImportedAccount, "pendingAccountId" | "createNewAccount">;
    kickAccountsById: Record<string, Account | undefined>;
}

export function resolveMappedKickAccount({
    account,
    kickAccountsById,
}: ResolveMappedKickAccountParams): Account | undefined {
    return account.pendingAccountId && !account.createNewAccount
        ? kickAccountsById[account.pendingAccountId]
        : undefined;
}

export function resolveImportedAccountDisplayType({
    isTypeReview,
    kickType,
    kickSubtype,
    mappedKickAccount,
}: {
    isTypeReview: boolean;
    kickType: AccountType | null;
    kickSubtype: AccountSubtype | null;
    mappedKickAccount: Pick<Account, "type" | "subtype"> | undefined;
}): {
    accountType: AccountType | null;
    accountSubtype: AccountSubtype | null;
} {
    if (isTypeReview || !mappedKickAccount) {
        return {
            accountType: kickType,
            accountSubtype: kickSubtype,
        };
    }

    return {
        accountType: mappedKickAccount.type,
        accountSubtype: mappedKickAccount.subtype,
    };
}
